/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_IcalInputs */

const cs_settings_profile_ical = /** @type {(inputs: Settings_Profile_IcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iCal odběr`)
};

const en_settings_profile_ical = /** @type {(inputs: Settings_Profile_IcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iCal subscribe`)
};

/**
* | output |
* | --- |
* | "iCal subscribe" |
*
* @param {Settings_Profile_IcalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_ical = /** @type {((inputs?: Settings_Profile_IcalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_IcalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_ical(inputs)
	return cs_settings_profile_ical(inputs)
});